import { gql } from "@apollo/client";

export const GET_ALL_LUGAR_SERVICIO = gql`
query GetLugarServicio
{
    allLugarServicio
    {
        idLugarServicio
        codigo
        descripcion
    }
}
`;

export const adaptLugarServicio = (lugarServicio) => {
  return {
    id: lugarServicio.idLugarServicio,
    displayName: lugarServicio.descripcion
  };
};

export const adaptLugarServicioArray = (
allLugarServicio) =>
{
  return structuredClone(allLugarServicio)?.
  map((lugarServicio) => adaptLugarServicio(lugarServicio));
};